var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-card',[_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"message":"Downloading..."}}),_vm._l((_vm.dashBoardLayout),function(item){return _c('div',{key:item.i,staticClass:"download-image",style:({
        width: `${_vm.downloadSizeInfo.get(item.i).width}px`,
      }),attrs:{"id":`${item.i}`}},[_c('div',{staticClass:"download-graph-title"},[_vm._v(_vm._s(item.graphTitle))]),_c('div',{staticClass:"graph-object"},[(item.graphType === 'documentFrequency')?_c('DocumentFrequency',{attrs:{"width":Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            ),"height":Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            ),"styles":{
            height: `${Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            )}px`,
            width: `${Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            )}px`,
          }}}):(item.graphType === 'approvalDocumentTimeAverage')?_c('ApprovalDocumentTimeAverage',{attrs:{"width":_vm.downloadSizeInfo.get(item.i).width,"height":_vm.downloadSizeInfo.get(item.i).height,"styles":{
            width: `${item.w * 160 - 10}px`,
            height: `${_vm.downloadSizeInfo.get(item.i).height}px`,
          }}}):(item.graphType === 'approvalTimeAverage')?_c('ApprovalTimeAverage',{attrs:{"width":_vm.downloadSizeInfo.get(item.i).width,"height":_vm.downloadSizeInfo.get(item.i).height,"styles":{
            width: `${item.w * 160 - 10}px`,
            height: `${_vm.downloadSizeInfo.get(item.i).height}px`,
          }}}):(item.graphType === 'documentRejectionRate')?_c('DocumentRejectionRate',{attrs:{"width":_vm.downloadSizeInfo.get(item.i).width,"height":_vm.downloadSizeInfo.get(item.i).height,"styles":{
            width: `${_vm.downloadSizeInfo.get(item.i).width}px`,
            height: `${_vm.downloadSizeInfo.get(item.i).height}px`,
          }}}):(item.graphType === 'userRejectionRate')?_c('UserRejectionRate',{attrs:{"width":_vm.downloadSizeInfo.get(item.i).width,"height":_vm.downloadSizeInfo.get(item.i).height,"styles":{
            width: `${_vm.downloadSizeInfo.get(item.i).width}px`,
            height: `${_vm.downloadSizeInfo.get(item.i).height}px`,
          }}}):_vm._e(),(item.graphType === 'deviceFrequency')?_c('DeviceFrequency',{attrs:{"width":Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            ),"height":Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            ),"styles":{
            height: `${Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            )}px`,
            width: `${Math.min(
              _vm.downloadSizeInfo.get(item.i).width,
              _vm.downloadSizeInfo.get(item.i).height
            )}px`,
          }}}):_c('Chart',{attrs:{"width":_vm.downloadSizeInfo.get(item.i).width,"height":_vm.downloadSizeInfo.get(item.i).height,"styles":{
            width: `${_vm.downloadSizeInfo.get(item.i).width}px`,
            height: `${_vm.downloadSizeInfo.get(item.i).height}px`,
          }}})],1),_c('div',{staticClass:"download-graph-description"},[_vm._v(" "+_vm._s(item.graphDescription)+" ")])])}),_c('v-btn',{staticStyle:{"visibility":"hidden"},attrs:{"color":"green darken-1","text":""},on:{"click":_vm.downloadDashBoardGraphs}},[_vm._v("Download")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }